export const menu = [
  // {
  //   name: '首页',
  //   path: '/',
  //   icon: 'home'
  // },
  // {
  //   name: '用户管理',
  //   path: '/user',
  //   icon: 'home'
  // },
  // {
  //   name: '真人认证审核',
  //   path: '/authentication',
  //   icon: 'home'
  // },
  // {
  //   name: 'pgc管理',
  //   path: '/pgc',
  //   icon: 'home'
  // },
  // {
  //   name: '嘉宾等级管理',
  //   icon: 'home',
  //   children: [
  //     {
  //       name: '嘉宾等级划分',
  //       path: '/level'
  //     },
  //     {
  //       name: '嘉宾等级花费',
  //       path: '/level/cost'
  //     },
  //     {
  //       name: '嘉宾等级收益',
  //       path: '/level/profit'
  //     },
  //     {
  //       name: '收益梯度管理',
  //       path: '/level/gradient'
  //     }
  //   ]
  // },
  // {
  //   name: '礼物配置',
  //   path: '/gift',
  //   icon: 'home'
  // },
  // {
  //   name: '任务管理',
  //   path: '/task',
  //   icon: 'home'
  // },
  // {
  //   name: 'Banner配置',
  //   path: '/banner',
  //   icon: 'home'
  // },
  // {
  //   name: '动态管理',
  //   path: '/ulog',
  //   icon: 'home'
  // },
  // {
  //   name: '文案库管理',
  //   path: '/copywriting',
  //   icon: 'home'
  // },
  // {
  //   name: '充值档位管理',
  //   icon: 'home',
  //   children: [
  //     {
  //       name: '充值档位管理',
  //       path: '/money'
  //     },
  //     {
  //       name: '发放积分',
  //       path: '/grant'
  //     }
  //   ]
  // },
  // {
  //   name: '数据明细',
  //   icon: 'home',
  //   children: [
  //     {
  //       name: '营收明细',
  //       path: '/revenuedata'
  //     },
  //     {
  //       name: '付费用户明细',
  //       path: '/payuserdata'
  //     },
  //     {
  //       name: '留存日明细',
  //       path: '/retaineduser'
  //     }
  //   ]
  // }
]
